import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _obj;
/* import __COLOCATED_TEMPLATE__ from './topic-list-item.hbs'; */
import { getOwner } from "@ember/application";
import Component, { setComponentTemplate } from "@ember/component";
import { alias } from "@ember/object/computed";
import { on } from "@ember/object/evented";
import { schedule } from "@ember/runloop";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import $ from "jquery";
import { topicTitleDecorators } from "discourse/components/topic-title";
import { wantsNewWindow } from "discourse/lib/intercept-click";
import DiscourseURL, { groupPath } from "discourse/lib/url";
import { RUNTIME_OPTIONS } from "discourse-common/lib/raw-handlebars-helpers";
import { findRawTemplate } from "discourse-common/lib/raw-templates";
import discourseComputed, { bind, observes } from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
import TEMPLATE from "./topic-list-item.hbs";
export function showEntrance(e) {
  let target = $(e.target);
  if (target.hasClass("posts-map") || target.parents(".posts-map").length > 0) {
    if (target.prop("tagName") !== "A") {
      target = target.find("a");
      if (target.length === 0) {
        target = target.end();
      }
    }
    this.appEvents.trigger("topic-entrance:show", {
      topic: this.topic,
      position: target.offset()
    });
    return false;
  }
}
export function navigateToTopic(topic, href) {
  const historyStore = getOwner(this).lookup("service:history-store");
  historyStore.set("lastTopicIdViewed", topic.id);
  DiscourseURL.routeTo(href || topic.get("url"));
  return false;
}
export default setComponentTemplate(TEMPLATE, Component.extend((_dec = observes("topic.highlight"), _dec2 = observes("topic.pinned", "expandGloballyPinned", "expandAllPinned"), _dec3 = discourseComputed("topic.participant_groups"), _dec4 = discourseComputed("topic.id"), _dec5 = discourseComputed("topic.unread_by_group_member"), _dec6 = discourseComputed("topic.unread_by_group_member"), _dec7 = discourseComputed("topic", "lastVisitedTopic"), (_obj = {
  router: service(),
  historyStore: service(),
  tagName: "tr",
  classNameBindings: [":topic-list-item", "unboundClassNames", "topic.visited"],
  attributeBindings: ["data-topic-id", "role", "ariaLevel:aria-level"],
  "data-topic-id": alias("topic.id"),
  didReceiveAttrs() {
    this._super(...arguments);
    this.renderTopicListItem();
  },
  topicHighlightChanged() {
    if (this.topic.highlight) {
      this._highlightIfNeeded();
    }
  },
  renderTopicListItem() {
    const template = findRawTemplate("list/topic-list-item");
    if (template) {
      this.set("topicListItemContents", htmlSafe(template(this, RUNTIME_OPTIONS)));
      schedule("afterRender", () => {
        if (this.isDestroyed || this.isDestroying) {
          return;
        }
        if (this.selected && this.selected.includes(this.topic)) {
          this.element.querySelector("input.bulk-select").checked = true;
        }
        if (this._shouldFocusLastVisited()) {
          const title = this._titleElement();
          if (title) {
            title.addEventListener("focus", this._onTitleFocus);
            title.addEventListener("blur", this._onTitleBlur);
          }
        }
      });
    }
  },
  didInsertElement() {
    this._super(...arguments);
    if (this.includeUnreadIndicator) {
      this.messageBus.subscribe(this.unreadIndicatorChannel, this.onMessage);
    }
    schedule("afterRender", () => {
      if (this.element && !this.isDestroying && !this.isDestroyed) {
        const rawTopicLink = this.element.querySelector(".raw-topic-link");
        rawTopicLink && topicTitleDecorators.forEach(cb => cb(this.topic, rawTopicLink, "topic-list-item-title"));
      }
    });
  },
  willDestroyElement() {
    this._super(...arguments);
    this.messageBus.unsubscribe(this.unreadIndicatorChannel, this.onMessage);
    if (this._shouldFocusLastVisited()) {
      const title = this._titleElement();
      if (title) {
        title.removeEventListener("focus", this._onTitleFocus);
        title.removeEventListener("blur", this._onTitleBlur);
      }
    }
  },
  onMessage(data) {
    const nodeClassList = document.querySelector(`.indicator-topic-${data.topic_id}`).classList;
    nodeClassList.toggle("read", !data.show_indicator);
  },
  participantGroups(groupNames) {
    if (!groupNames) {
      return [];
    }
    return groupNames.map(name => {
      return {
        name,
        url: groupPath(name)
      };
    });
  },
  unreadIndicatorChannel(topicId) {
    return `/private-messages/unread-indicator/${topicId}`;
  },
  unreadClass(unreadByGroupMember) {
    return unreadByGroupMember ? "" : "read";
  },
  includeUnreadIndicator(unreadByGroupMember) {
    return typeof unreadByGroupMember !== "undefined";
  },
  newDotText() {
    return this.currentUser && this.currentUser.trust_level > 0 ? "" : I18n.t("filters.new.lower_title");
  },
  unboundClassNames(topic, lastVisitedTopic) {
    let classes = [];
    if (topic.get("category")) {
      classes.push("category-" + topic.get("category.fullSlug"));
    }
    if (topic.get("tags")) {
      topic.get("tags").forEach(tagName => classes.push("tag-" + tagName));
    }
    if (topic.get("hasExcerpt")) {
      classes.push("has-excerpt");
    }
    if (topic.get("unseen")) {
      classes.push("unseen-topic");
    }
    if (topic.unread_posts) {
      classes.push("unread-posts");
    }
    ["liked", "archived", "bookmarked", "pinned", "closed"].forEach(name => {
      if (topic.get(name)) {
        classes.push(name);
      }
    });
    if (topic === lastVisitedTopic) {
      classes.push("last-visit");
    }
    return classes.join(" ");
  },
  hasLikes() {
    return this.get("topic.like_count") > 0;
  },
  hasOpLikes() {
    return this.get("topic.op_like_count") > 0;
  },
  expandPinned() {
    const pinned = this.get("topic.pinned");
    if (!pinned) {
      return false;
    }
    if (this.site.mobileView) {
      if (!this.siteSettings.show_pinned_excerpt_mobile) {
        return false;
      }
    } else {
      if (!this.siteSettings.show_pinned_excerpt_desktop) {
        return false;
      }
    }
    if (this.expandGloballyPinned && this.get("topic.pinned_globally")) {
      return true;
    }
    if (this.expandAllPinned) {
      return true;
    }
    return false;
  },
  showEntrance,
  click(e) {
    const result = this.showEntrance(e);
    if (result === false) {
      return result;
    }
    const topic = this.topic;
    const target = e.target;
    const classList = target.classList;
    if (classList.contains("bulk-select")) {
      const selected = this.selected;
      if (target.checked) {
        selected.addObject(topic);
        if (this.lastChecked && e.shiftKey) {
          const bulkSelects = Array.from(document.querySelectorAll("input.bulk-select")),
            from = bulkSelects.indexOf(target),
            to = bulkSelects.findIndex(el => el.id === this.lastChecked.id),
            start = Math.min(from, to),
            end = Math.max(from, to);
          bulkSelects.slice(start, end).filter(el => el.checked !== true).forEach(checkbox => {
            checkbox.click();
          });
        }
        this.set("lastChecked", target);
      } else {
        selected.removeObject(topic);
        this.set("lastChecked", null);
      }
    }
    if (classList.contains("raw-topic-link") || classList.contains("post-activity")) {
      if (wantsNewWindow(e)) {
        return true;
      }
      e.preventDefault();
      return this.navigateToTopic(topic, target.getAttribute("href"));
    }

    // make full row click target on mobile, due to size constraints
    if (this.site.mobileView && e.target.matches(".topic-list-data, .main-link, .right, .topic-item-stats, .topic-item-stats__category-tags, .discourse-tags")) {
      if (wantsNewWindow(e)) {
        return true;
      }
      e.preventDefault();
      return this.navigateToTopic(topic, topic.lastUnreadUrl);
    }
    if (classList.contains("d-icon-thumbtack") && target.closest("a.topic-status")) {
      this.topic.togglePinnedForUser();
      return false;
    }
    return this.unhandledRowClick(e, topic);
  },
  unhandledRowClick() {},
  keyDown(e) {
    if (e.key === "Enter" && e.target.classList.contains("post-activity")) {
      e.preventDefault();
      return this.navigateToTopic(this.topic, e.target.getAttribute("href"));
    }
  },
  navigateToTopic,
  highlight() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      isLastViewedTopic: false
    };
    schedule("afterRender", () => {
      if (!this.element || this.isDestroying || this.isDestroyed) {
        return;
      }
      this.element.classList.add("highlighted");
      this.element.setAttribute("data-islastviewedtopic", opts.isLastViewedTopic);
      this.element.addEventListener("animationend", () => {
        this.element.classList.remove("highlighted");
      });
      if (opts.isLastViewedTopic && this._shouldFocusLastVisited()) {
        this._titleElement()?.focus();
      }
    });
  },
  _highlightIfNeeded: on("didInsertElement", function () {
    // highlight the last topic viewed
    const lastViewedTopicId = this.historyStore.get("lastTopicIdViewed");
    const isLastViewedTopic = lastViewedTopicId === this.topic.id;
    if (isLastViewedTopic) {
      this.historyStore.delete("lastTopicIdViewed");
      this.highlight({
        isLastViewedTopic: true
      });
    } else if (this.get("topic.highlight")) {
      // highlight new topics that have been loaded from the server or the one we just created
      this.set("topic.highlight", false);
      this.highlight();
    }
  }),
  _onTitleFocus() {
    if (this.element && !this.isDestroying && !this.isDestroyed) {
      this.element.classList.add("selected");
    }
  },
  _onTitleBlur() {
    if (this.element && !this.isDestroying && !this.isDestroyed) {
      this.element.classList.remove("selected");
    }
  },
  _shouldFocusLastVisited() {
    return this.site.desktopView && this.focusLastVisitedTopic;
  },
  _titleElement() {
    return this.element.querySelector(".main-link .title");
  }
}, (_applyDecoratedDescriptor(_obj, "topicHighlightChanged", [_dec], Object.getOwnPropertyDescriptor(_obj, "topicHighlightChanged"), _obj), _applyDecoratedDescriptor(_obj, "renderTopicListItem", [_dec2], Object.getOwnPropertyDescriptor(_obj, "renderTopicListItem"), _obj), _applyDecoratedDescriptor(_obj, "onMessage", [bind], Object.getOwnPropertyDescriptor(_obj, "onMessage"), _obj), _applyDecoratedDescriptor(_obj, "participantGroups", [_dec3], Object.getOwnPropertyDescriptor(_obj, "participantGroups"), _obj), _applyDecoratedDescriptor(_obj, "unreadIndicatorChannel", [_dec4], Object.getOwnPropertyDescriptor(_obj, "unreadIndicatorChannel"), _obj), _applyDecoratedDescriptor(_obj, "unreadClass", [_dec5], Object.getOwnPropertyDescriptor(_obj, "unreadClass"), _obj), _applyDecoratedDescriptor(_obj, "includeUnreadIndicator", [_dec6], Object.getOwnPropertyDescriptor(_obj, "includeUnreadIndicator"), _obj), _applyDecoratedDescriptor(_obj, "newDotText", [discourseComputed], Object.getOwnPropertyDescriptor(_obj, "newDotText"), _obj), _applyDecoratedDescriptor(_obj, "unboundClassNames", [_dec7], Object.getOwnPropertyDescriptor(_obj, "unboundClassNames"), _obj), _applyDecoratedDescriptor(_obj, "expandPinned", [discourseComputed], Object.getOwnPropertyDescriptor(_obj, "expandPinned"), _obj), _applyDecoratedDescriptor(_obj, "_onTitleFocus", [bind], Object.getOwnPropertyDescriptor(_obj, "_onTitleFocus"), _obj), _applyDecoratedDescriptor(_obj, "_onTitleBlur", [bind], Object.getOwnPropertyDescriptor(_obj, "_onTitleBlur"), _obj)), _obj))));